"use strict";
import Ports from "./hubtran/ports";
function preventScroll(e) {
  switch (e.key) {
    case "ArrowUp":
    case "ArrowDown":
    case "ArrowLeft":
    case "ArrowRight":
    case " ":
      e.preventDefault();
      break;
    default:
      break;
  }
}
const disableScrollByContainerId = (containerId) => {
  const container = document.getElementById(containerId);
  if (container) {
    container.addEventListener("keydown", preventScroll, false);
  }
};
const scrollToId = (payload) => {
  const listSelector = `#${payload.listId}`;
  const escapedOptionId = payload.optionId.replace(/"/g, '\\"');
  const optionSelector = `${listSelector} li[data-option="${escapedOptionId}"]`;
  const optionElement = document.querySelector(optionSelector);
  if (optionElement) {
    optionElement.scrollIntoView({ block: "nearest", inline: "nearest" });
  }
};
const applyPorts = (app) => {
  const ports = new Ports(app);
  ports.safeSubscribe("v3DisableScrollByContainerId", disableScrollByContainerId);
  ports.safeSubscribe("v3ScrollToId", scrollToId);
};
const UiV3 = { applyPorts };
export default UiV3;
